import { OrderModel } from "../order/OrderModel";

export class CashModel {
  id?: string;
  name: string;
  session?: CashSessionModel | null;

  constructor(data: Partial<CashModel> | any = {}) {
    this.id = data.id;
    this.name = data.name;
    this.session = data.session ? new CashSessionModel(data.session) : null;
  }
}

export class CashSessionModel {
  id: string;
  cashId: string;
  openedBy: string;
  openedAt: Date;
  closedBy?: string;
  closedAt?: Date;
  openingBalance: number;
  reportedBalance: number;
  closingBalance: number;
  difference: number;
  status: CashStatusEnum;
  orders: OrderModel[];

  constructor(data: Partial<CashSessionModel> | any = {}) {
    this.id = data.id;
    this.cashId = data.cashId;
    this.openedBy = data.openedBy;
    this.openedAt = new Date(data.openedAt);
    this.closedBy = data.closedBy ?? null;
    this.closedAt = data.closedAt ? new Date(data.closedAt) : undefined;
    this.openingBalance = Number(data.openingBalance ?? 0);
    this.reportedBalance = Number(data.reportedBalance ?? 0);
    this.closingBalance = Number(data.closingBalance ?? 0);
    this.difference = Number(data.difference ?? 0);
    this.status = data.status;
    this.orders = Array.isArray(data.orders)
      ? data.orders.map((order: any) => new OrderModel(order))
      : [];
  }
}

export enum CashStatusEnum {
  OPENING = "OPENING",
  CLOSING = "CLOSING",
}

export const STATUS_COLORS_CASH: Record<CashStatusEnum, string> = {
  [CashStatusEnum.OPENING]: "#4caf50",
  [CashStatusEnum.CLOSING]: "#ff9800",
};

export const STATUS_LABELS_CASH: Record<CashStatusEnum, string> = {
  OPENING: "Abierta",
  CLOSING: "Cerrada",
};
